/**
 * TableHeader.jsx
 *
 * @Author: apple
 * @Date: 2018/3/7 14:31
 */

import React from 'react';
import TableHeaderRow from './TableHeaderRow';
import ColGroup from './colGroup';

/**
 * @ignore
 * */
class TableHeader extends React.Component {
  static propTypes = {};

  static defaultProps = {};

  getTableHeader = el => {
    const { tableHeaderRef } = this.props;
    tableHeaderRef && tableHeaderRef(el);
  };

  render() {
    const {
      theadClassName,
      renderColumns,
      handleSetSort,
      sortState,
      onClickTh,
      textCenter,
      tdWidthArray,
      position,
      prefixCls,
      expandRow,
      handleBodyScrollLeft,
      tableHeaderRef,
      tableHeaderRowRef,
      width,
      height,
      warpWidth,
    } = this.props;

    const tableHeaderRowPrefixCls = `${prefixCls}-header`;
    const tableHeaderRowProps = {
      theadClassName,
      renderColumns,
      handleSetSort,
      sortState,
      onClickTh,
      textCenter,
      tdWidthArray,
      position,
      prefixCls: tableHeaderRowPrefixCls,
      tableHeaderRef,
      tableHeaderRowRef,
      expandRow,
      height,
    };
    return (
      <div
        style={{ width: warpWidth }}
        className={tableHeaderRowPrefixCls}
        onScroll={handleBodyScrollLeft}
        ref={this.getTableHeader}>
        <table style={{ width }}>
          <ColGroup renderColumns={renderColumns} />
          <TableHeaderRow {...tableHeaderRowProps} />
        </table>
      </div>
    );
  }
}

export default TableHeader;



// WEBPACK FOOTER //
// ./src/table/TableHeader.jsx